// extracted by mini-css-extract-plugin
export var imageWrapper = "metamorphosis-module--image-wrapper--2jGtj";
export var textWrapper = "metamorphosis-module--text-wrapper--Akvr6";
export var wrapper = "metamorphosis-module--wrapper--oFp2Y";